import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

import {getBigDataApiPath} from "../../../../../utils/get_big_data_api_path";
import prepareHeaders from "../../../store/prepare_headers";

export interface ICheckoutSessionPayload {
    price_id: string;
    success_url: string;
    cancel_url: string;
}

export interface ICheckoutSessionResponse {
    url: string;
}

export interface ISubscription {
    id: number;
    stripe_subscription_id: string;
    stripe_price_id: string;
    status: string;
    current_period_end: string | null;
    cancel_at_period_end: boolean;
    create_date: string;
}

export interface ISyncSubscriptionsResponse {
    synced_count: number;
    subscriptions: ISubscription[];
}

export const subscriptionsApi = createApi({
    reducerPath: "subscriptionsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${getBigDataApiPath()}subscriptions/`,
        prepareHeaders,
        credentials: "include"
    }),
    endpoints: (build) => ({
        createCheckoutSession: build.mutation<ICheckoutSessionResponse, ICheckoutSessionPayload>({
            query: (body) => ({
                url: "checkout/",
                method: "POST",
                body
            })
        }),
        syncSubscriptions: build.mutation<ISyncSubscriptionsResponse, void>({
            query: () => ({
                url: "sync/",
                method: "POST"
            })
        })
    })
});

export const {useCreateCheckoutSessionMutation, useSyncSubscriptionsMutation} = subscriptionsApi;
